import {
  GET_POSTINGS,
  UPDATE_ABROAD_POSTING_INFO,
  UPDATE_ATTACHMENT_POSTING_INFO,
  UPDATE_CONTRACTUAL_POSTING_INFO,
  UPDATE_DEPUTATION_POSTING_INFO,
  UPDATE_POSTING_RECORD_POSTING_INFO,
  UPDATE_FOREIGN_TRAVEL_POSTING_INFO,
  DELETE_ABROAD_POSTING_INFO,
  DELETE_ATTACHMENT_POSTING_INFO,
  DELETE_CONTRACTUAL_POSTING_INFO,
  DELETE_DEPUTATION_POSTING_INFO,
  DELETE_POSTING_RECORD_POSTING_INFO,
  DELETE_FOREIGN_TRAVEL_POSTING_INFO,
} from "./types";
import {
  PostingsType,
  AbroadPostingType,
  AttachmentPostingType,
  ContractualPostingType,
  DeputationPostingType,
  PostingRecordPostingType,
  ForeignTravelPostingType,
} from "@type/HRM/postings";

export const getPostingsRequest = (data: number | null) => {
  return {
    type: GET_POSTINGS.GET_POSTINGS_REQUEST,
    payload: { data },
  } as const;
};

export const getPostingsSuccess = (data: PostingsType) => {
  return {
    type: GET_POSTINGS.GET_POSTINGS_SUCCESS,
    payload: { data },
  } as const;
};

export const getPostingsFailed = () => {
  return {
    type: GET_POSTINGS.GET_POSTINGS_FAILED,
  } as const;
};

export const updateAbroadPostingsInfoRequest = (data: AbroadPostingType) => {
  return {
    type: UPDATE_ABROAD_POSTING_INFO.UPDATE_ABROAD_POSTING_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const updateAbroadPostingsInfoSuccess = (data: AbroadPostingType) => {
  return {
    type: UPDATE_ABROAD_POSTING_INFO.UPDATE_ABROAD_POSTING_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const updateAbroadPostingsInfoFailed = () => {
  return {
    type: UPDATE_ABROAD_POSTING_INFO.UPDATE_ABROAD_POSTING_INFO_FAILED,
  } as const;
};

export const updateAttachmentPostingsInfoRequest = (
  data: AttachmentPostingType
) => {
  return {
    type: UPDATE_ATTACHMENT_POSTING_INFO.UPDATE_ATTACHMENT_POSTING_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const updateAttachmentPostingsInfoSuccess = (
  data: AttachmentPostingType
) => {
  return {
    type: UPDATE_ATTACHMENT_POSTING_INFO.UPDATE_ATTACHMENT_POSTING_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const updateAttachmentPostingsInfoFailed = () => {
  return {
    type: UPDATE_ATTACHMENT_POSTING_INFO.UPDATE_ATTACHMENT_POSTING_INFO_FAILED,
  } as const;
};

export const updateContractualPostingsInfoRequest = (
  data: ContractualPostingType
) => {
  return {
    type:
      UPDATE_CONTRACTUAL_POSTING_INFO.UPDATE_CONTRACTUAL_POSTING_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const updateContractualPostingsInfoSuccess = (
  data: ContractualPostingType
) => {
  return {
    type:
      UPDATE_CONTRACTUAL_POSTING_INFO.UPDATE_CONTRACTUAL_POSTING_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const updateContractualPostingsInfoFailed = () => {
  return {
    type:
      UPDATE_CONTRACTUAL_POSTING_INFO.UPDATE_CONTRACTUAL_POSTING_INFO_FAILED,
  } as const;
};

export const updateDeputationPostingsInfoRequest = (
  data: DeputationPostingType
) => {
  return {
    type: UPDATE_DEPUTATION_POSTING_INFO.UPDATE_DEPUTATION_POSTING_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const updateDeputationPostingsInfoSuccess = (
  data: DeputationPostingType
) => {
  return {
    type: UPDATE_DEPUTATION_POSTING_INFO.UPDATE_DEPUTATION_POSTING_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const updateDeputationPostingsInfoFailed = () => {
  return {
    type: UPDATE_DEPUTATION_POSTING_INFO.UPDATE_DEPUTATION_POSTING_INFO_FAILED,
  } as const;
};

export const updatePostingRecordPostingsInfoRequest = (
  data: PostingRecordPostingType
) => {
  return {
    type:
      UPDATE_POSTING_RECORD_POSTING_INFO.UPDATE_POSTING_RECORD_POSTING_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const updatePostingRecordPostingsInfoSuccess = (
  data: PostingRecordPostingType
) => {
  return {
    type:
      UPDATE_POSTING_RECORD_POSTING_INFO.UPDATE_POSTING_RECORD_POSTING_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const updatePostingRecordPostingsInfoFailed = () => {
  return {
    type:
      UPDATE_POSTING_RECORD_POSTING_INFO.UPDATE_POSTING_RECORD_POSTING_INFO_FAILED,
  } as const;
};

export const updateForeignTravelPostingsInfoRequest = (
  data: ForeignTravelPostingType
) => {
  return {
    type:
      UPDATE_FOREIGN_TRAVEL_POSTING_INFO.UPDATE_FOREIGN_TRAVEL_POSTING_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const updateForeignTravelPostingsInfoSuccess = (
  data: ForeignTravelPostingType
) => {
  return {
    type:
      UPDATE_FOREIGN_TRAVEL_POSTING_INFO.UPDATE_FOREIGN_TRAVEL_POSTING_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const updateForeignTravelPostingsInfoFailed = () => {
  return {
    type:
      UPDATE_FOREIGN_TRAVEL_POSTING_INFO.UPDATE_FOREIGN_TRAVEL_POSTING_INFO_FAILED,
  } as const;
};

export const deleteAbroadPostingInfoRequest = (data: {
  employeeID: number | null;
  abroadPostingID: number;
}) => {
  return {
    type: DELETE_ABROAD_POSTING_INFO.DELETE_ABROAD_POSTING_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const deleteAbroadPostingInfoSuccess = (data: { id: number }) => {
  return {
    type: DELETE_ABROAD_POSTING_INFO.DELETE_ABROAD_POSTING_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const deleteAbroadPostingInfoFailed = () => {
  return {
    type: DELETE_ABROAD_POSTING_INFO.DELETE_ABROAD_POSTING_INFO_FAILED,
  } as const;
};

export const deleteAttachmentPostingInfoRequest = (data: {
  employeeID: number | null;
  attachmentPostingID: number;
}) => {
  return {
    type: DELETE_ATTACHMENT_POSTING_INFO.DELETE_ATTACHMENT_POSTING_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const deleteAttachmentPostingInfoSuccess = (data: { id: number }) => {
  return {
    type: DELETE_ATTACHMENT_POSTING_INFO.DELETE_ATTACHMENT_POSTING_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const deleteAttachmentPostingInfoFailed = () => {
  return {
    type: DELETE_ATTACHMENT_POSTING_INFO.DELETE_ATTACHMENT_POSTING_INFO_FAILED,
  } as const;
};

export const deleteContractualPostingInfoRequest = (data: {
  employeeID: number | null;
  contractualPostingID: number;
}) => {
  return {
    type:
      DELETE_CONTRACTUAL_POSTING_INFO.DELETE_CONTRACTUAL_POSTING_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const deleteContractualPostingInfoSuccess = (data: { id: number }) => {
  return {
    type:
      DELETE_CONTRACTUAL_POSTING_INFO.DELETE_CONTRACTUAL_POSTING_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const deleteContractualPostingInfoFailed = () => {
  return {
    type:
      DELETE_CONTRACTUAL_POSTING_INFO.DELETE_CONTRACTUAL_POSTING_INFO_FAILED,
  } as const;
};

export const deleteDeputationPostingInfoRequest = (data: {
  employeeID: number | null;
  deputationPostingID: number;
}) => {
  return {
    type: DELETE_DEPUTATION_POSTING_INFO.DELETE_DEPUTATION_POSTING_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const deleteDeputationPostingInfoSuccess = (data: { id: number }) => {
  return {
    type: DELETE_DEPUTATION_POSTING_INFO.DELETE_DEPUTATION_POSTING_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const deleteDeputationPostingInfoFailed = () => {
  return {
    type: DELETE_DEPUTATION_POSTING_INFO.DELETE_DEPUTATION_POSTING_INFO_FAILED,
  } as const;
};

export const deletePostingRecordPostingInfoRequest = (data: {
  employeeID: number | null;
  postingRecordPostingID: number;
}) => {
  return {
    type:
      DELETE_POSTING_RECORD_POSTING_INFO.DELETE_POSTING_RECORD_POSTING_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const deletePostingRecordPostingInfoSuccess = (data: { id: number }) => {
  return {
    type:
      DELETE_POSTING_RECORD_POSTING_INFO.DELETE_POSTING_RECORD_POSTING_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const deletePostingRecordPostingInfoFailed = () => {
  return {
    type:
      DELETE_POSTING_RECORD_POSTING_INFO.DELETE_POSTING_RECORD_POSTING_INFO_FAILED,
  } as const;
};

export const deleteForeignTravelPostingInfoRequest = (data: {
  employeeID: number | null;
  foreignTravelPostingID: number;
}) => {
  return {
    type:
      DELETE_FOREIGN_TRAVEL_POSTING_INFO.DELETE_FOREIGN_TRAVEL_POSTING_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const deleteForeignTravelPostingInfoSuccess = (data: { id: number }) => {
  return {
    type:
      DELETE_FOREIGN_TRAVEL_POSTING_INFO.DELETE_FOREIGN_TRAVEL_POSTING_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const deleteForeignTravelPostingInfoFailed = () => {
  return {
    type:
      DELETE_FOREIGN_TRAVEL_POSTING_INFO.DELETE_FOREIGN_TRAVEL_POSTING_INFO_FAILED,
  } as const;
};

export type PostingActions =
  | ReturnType<typeof getPostingsRequest>
  | ReturnType<typeof getPostingsSuccess>
  | ReturnType<typeof getPostingsFailed>
  | ReturnType<typeof updateAbroadPostingsInfoRequest>
  | ReturnType<typeof updateAbroadPostingsInfoSuccess>
  | ReturnType<typeof updateAbroadPostingsInfoFailed>
  | ReturnType<typeof updateAttachmentPostingsInfoRequest>
  | ReturnType<typeof updateAttachmentPostingsInfoSuccess>
  | ReturnType<typeof updateAttachmentPostingsInfoFailed>
  | ReturnType<typeof updateContractualPostingsInfoRequest>
  | ReturnType<typeof updateContractualPostingsInfoSuccess>
  | ReturnType<typeof updateContractualPostingsInfoFailed>
  | ReturnType<typeof updateDeputationPostingsInfoRequest>
  | ReturnType<typeof updateDeputationPostingsInfoSuccess>
  | ReturnType<typeof updateDeputationPostingsInfoFailed>
  | ReturnType<typeof updatePostingRecordPostingsInfoRequest>
  | ReturnType<typeof updatePostingRecordPostingsInfoSuccess>
  | ReturnType<typeof updatePostingRecordPostingsInfoFailed>
  | ReturnType<typeof updateForeignTravelPostingsInfoRequest>
  | ReturnType<typeof updateForeignTravelPostingsInfoSuccess>
  | ReturnType<typeof updateForeignTravelPostingsInfoFailed>
  | ReturnType<typeof deleteAbroadPostingInfoRequest>
  | ReturnType<typeof deleteAbroadPostingInfoSuccess>
  | ReturnType<typeof deleteAbroadPostingInfoFailed>
  | ReturnType<typeof deleteAttachmentPostingInfoRequest>
  | ReturnType<typeof deleteAttachmentPostingInfoSuccess>
  | ReturnType<typeof deleteAttachmentPostingInfoFailed>
  | ReturnType<typeof deleteContractualPostingInfoRequest>
  | ReturnType<typeof deleteContractualPostingInfoSuccess>
  | ReturnType<typeof deleteContractualPostingInfoFailed>
  | ReturnType<typeof deleteDeputationPostingInfoRequest>
  | ReturnType<typeof deleteDeputationPostingInfoSuccess>
  | ReturnType<typeof deleteDeputationPostingInfoFailed>
  | ReturnType<typeof deletePostingRecordPostingInfoRequest>
  | ReturnType<typeof deletePostingRecordPostingInfoSuccess>
  | ReturnType<typeof deletePostingRecordPostingInfoFailed>
  | ReturnType<typeof deleteForeignTravelPostingInfoRequest>
  | ReturnType<typeof deleteForeignTravelPostingInfoSuccess>
  | ReturnType<typeof deleteForeignTravelPostingInfoFailed>;
